import { render, staticRenderFns } from "./ifame2.vue?vue&type=template&id=7d3bb843&scoped=true&"
import script from "./ifame2.vue?vue&type=script&lang=js&"
export * from "./ifame2.vue?vue&type=script&lang=js&"
import style0 from "./ifame2.vue?vue&type=style&index=0&id=7d3bb843&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3bb843",
  null
  
)

export default component.exports